import { FC } from 'react';
import { Tooltip } from './Tooltip';

const NOUNS = {
  email: ['email', 'emails'],
  sms: ['message', 'messages'],
} as const;

/**
 * The message count on a row that stands for a whole conversation ("8 emails",
 * "34 messages"). The API sends the whole thread's count even when the list is
 * date-filtered, so the tooltip says so; it matches the thread view's header.
 */
export const ThreadCount: FC<{
  count: number;
  channel: keyof typeof NOUNS;
  className?: string;
}> = ({ count, channel, className = '' }) => {
  const label = `${count} ${NOUNS[channel][count === 1 ? 0 : 1]}`;
  return (
    <Tooltip content={`${label} in this conversation, all time`}>
      <span className={`tabular-nums whitespace-nowrap ${className}`}>{label}</span>
    </Tooltip>
  );
};
